
const agent = {
  createNew: {
    newReservation: 'Neue Reservierung',
    quickReservation: 'Schnelle Reservierung',
  },

  searchBox: {
    searchBtn: 'Suchen',
  },

  table: {
    myLastBookingsTable: {
      title: 'Meine letzten Buchungen',
      headers: {
        id: 'Ausweis',
        date: 'Datum',
        status: 'Status',
        passenger: 'Fahrgast',
      },
    },
    myRecentViewsTable: {
      title: 'Meine letzten Ansichten',
      headers: {
        id: 'Ausweis',
        date: 'Datum',
        status: 'Status',
        passenger: 'Fahrgast',
      },
    },
  },

  statistics: {
    lastWeek: {
      title: 'Letzte Woche',
    },
    last24Hours: {
      title: 'Letzte 24 Stunden',
    },
    myLastWeek: {
      title: 'Meine letzte Woche',
    },
    myLast24Hours: {
      title: 'Meine letzten 24 Stunden',
    },
  },

  weatherInfo: {
    title: 'Wetter',
    noNewMessages: 'Keine neuen Nachrichten',
    loadingWeather: 'Wetter wird geladen..,',
  },

  radioButton: {
    showTen: '10',
    showFive: '5',
  },
};

export default agent;
